var debug = require('debug')('MKSZ:stopwatch');
function Stopwatch(options) {
    var offset, interval;
    var clock = 0;
    var perioditems = null;
    // default options
    options = options || {};
    options.delay = options.delay || 1;

    // initialize
    reset();

    function start() {
        if (!interval) {
            offset = Date.now();
            interval = setInterval(update, options.delay);
        }
    }

    function stop() {
        if (interval) {
            clearInterval(interval);
            interval = null;
        }
    }

    function save(){
        perioditems = window.gamedata.periods;
        debug(perioditems);
    }

    function reset() {
        clock = 0;

        debug(perioditems);
    }

    function setClockToPeriod(){
        perioditems = window.gamedata.periods;
        clock = 0;
    }

    function update() {
        clock += delta();
    }

    function setTime(_time) {
        perioditems = window.gamedata.periods;
        clock = _time * 1000;
    }

    /**
     * Az adott perióduson belül mennyi az idő
     *
     * @return float
     */
    function getTime() {
        return clock / 1000;
    }

    function delta() {
        var now = Date.now(),
            d = now - offset;

        offset = now;
        return d;
    }

    /**
     * A korábbi periódusok milyen hosszúak voltak (a jelenlegi NEM számít bele)
     *
     * @return int
     */
    function getTrueTotalTime() {
        // JAVÍTÁS: a perioditems egy MANUÁLISAN gyorsítótárazott másolat, amit csak a
        // save()/setClockToPeriod()/setTime() hívásakor frissítünk. Ha a
        // window.gamedata (pl. reconnect/offline resync után, loadGameData()-ból) új,
        // helyes periódus-adatokkal frissül, DE ezek a függvények nem futnak le újra
        // (pl. mert a periódus maga nem változott, csak az adat mögötte), a
        // gyorsítótár elavult marad, és ez rossz totalGameTime-ot eredményezett
        // offline rögzített eseményeknél. Mindig a friss, élő gamedata-t részesítjük
        // előnyben, a gyorsítótár csak akkor a tartalék, ha az élő adat még nem
        // érhető el.
        let items = (window.gamedata && window.gamedata.periods) ? window.gamedata.periods : perioditems;

        if (!items) {
            return 0;
        }

        let pItem = items.find((p) => p.value === window.period);
        return pItem ? (pItem.startat || 0) : 0;
    }

    /**
     * A jelenlegi idő
     *
     * @uses getTime
     * @uses getTrueTotalTime
     *
     * @return int
     */
    function getTotalTime() {
        return getTrueTotalTime() + Math.floor(getTime());
    }

    function getTotalTimeAsString() {
        let t = Math.floor(getTotalTime());
        let tmin = Math.floor(t / 60);
        let tsec = t - tmin * 60;
        let minutes = tmin.toString().length === 1 ? "0".concat(tmin.toString()) : tmin;
        let seconds = tsec.toString().length === 1 ? "0".concat(tsec.toString()) : tsec;
        return minutes + ":" + seconds;
    }

    // public API
    this.start = start;
    this.stop = stop;
    this.reset = reset;
    this.save = save;
    this.setTime = setTime;
    this.getTime = getTime;
    this.clock = clock;
    this.getTotalTime = getTotalTime;
    this.getTotalTimeAsString = getTotalTimeAsString;
    this.getTrueTotalTime = getTrueTotalTime;
    this.perioditems = perioditems;
    this.setClockToPeriod = setClockToPeriod;
}

module.exports = new Stopwatch();
